import { apiClient } from "src/api/apiService";
import { ApiResponseType } from "./types";

export const postCloseTransferCheckStatus = async (journeyId: string) => {
  // TODO https://origindd.atlassian.net/browse/LOC-1179
  const response = await apiClient.post<ApiResponseType>(
    `/close-transfer/check-status`,
    {
      journey_id: journeyId,
    }
  );
  return response.data;
};

/* istanbul ignore next */
export const mockPostCloseTransferCheckStatusMarkComplete = async (
  journeyId: string
) => {
  console.log(journeyId);
  await new Promise((resolve) => setTimeout(resolve, 1000));
  const response = {
    data: {
      journeyId: "12344567",
      checkOutcome: "MARK_COMPLETE", // account already closed
      requestingCompany: "Example Corp Completed",
    } as ApiResponseType,
  };
  return response.data;
};

/* istanbul ignore next */
export const mockPostCloseTransferCheckStatusUnresolved = async (
  journeyId: string
) => {
  console.log(journeyId);
  await new Promise((resolve) => setTimeout(resolve, 1000));

  const response = {
    data: {
      journeyId: "12344567",
      checkOutcome: "UNRESOLVED", // as-is
      requestingCompany: "Example Corp Unresolved",
    } as ApiResponseType,
  };
  return response.data;
};
